export default {
	/**
	 * Returns a token for the given username and password.
	 * @param {string} username The account username
	 * @param {string} password The account password
	 * @returns {Promise<string>} The access token
	 */
	async get (username, password) {}
};
